import React, { Component } from 'react';
import { Router, browserHistory, Route, Link } from 'react-router';
import './App.css';
import Login from './container/Login';
import Tasks from './container/Tasks';
import History from './container/History';

class App extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path="/" component={Login}/>
        <Route path="/tasks" component={Tasks}/> 
        <Route path="/history" component={History}/>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js